import { gql } from '@apollo/client';

export const brexitProductInfoFieldsCustomsDeclarationFragment = gql`
  fragment brexitProductInfoFieldsCustomsDeclaration on CustomsDeclaration {
    group {
      shipment {
        legs {
          conveyance {
            grossWeight
          }
        }
      }
    }
    goodsShipment {
      importCountry {
        country
      }
      goodsItem {
        goodsMeasure {
          tariff
        }
        commodity {
          product {
            clientIdentifier
            clientIdentifierVersion
            secondaryIdentifiers {
              type
              value
            }
          }
        }
      }
    }
  }
`;
